import React from "react";
import LoginSignup from "../components/otherPageComponent/LoginSignup";
import SEO from "../components/SEO";
// import { Login } from '@mui/icons-material';

function AuthPage() {
  return (
    <>
      <SEO
        title="Login - Aastha Computers"
        description="Access your student portal at Aastha Computes, Bikaner. Login to manage your courses, track progress, and stay updated with announcements and schedules."
        pagePath="/login"
      />
      <LoginSignup />
    </>
  );
}

export default AuthPage;
